import { render, staticRenderFns } from "./UncancelOrderModal.vue?vue&type=template&id=fd22b4b2"
import script from "./UncancelOrderModal.vue?vue&type=script&lang=ts"
export * from "./UncancelOrderModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports